export default __webpack_public_path__ + "static/media/usuario-micuenta.be33bb01.svg";